'use client';

import { useGtmTrack } from '../index';
import { ANALYTICS_EVENTS } from '../types';
import type { LandingPageExperimentViewedProps, TrackingFunction } from '../types';

export const useLandingPageExperimentTracking = (
  props: LandingPageExperimentViewedProps,
  autoTrack: boolean = false,
): TrackingFunction => {
  return useGtmTrack(
    {
      eventName: ANALYTICS_EVENTS.LANDING_PAGE_EXPERIMENT_VIEWED,
      properties: props,
    },
    autoTrack,
  );
};
